define('shared/initializer/form/adapters/mixins/InvalidOfferPageLoadBlockable',[
    'shared/lib/RSVP'
], 
function (RSVP) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function( ) {
        return RSVP.all(this.dfdOfferValidatable);
    };

    return Ctor;
});
